import React from "react";
import NO_AVA_BIG from "styles/img/no-ava-big.png";
import { withRouter, Link } from "react-router-dom";
import { inject, observer } from "mobx-react";

@inject("user")
@observer
@withRouter
export class ProviderCard extends React.Component {
  // provider = this.props.provider;

  redirectTo = () => {
    this.props.redirectToProvider(this.props.provider.id);
  };

  handleOpenDeleteModal = e => {
    this.props.handleDeleteProvider(e, this.props.provider.id);
  };

  handleEditProvider = e => {
    this.props.handleEditProvider(e, this.props.provider.id);
  };

  render() {
    const provider = this.props.provider;
    return (
      <div className="provider-card-wrapper col-12 col-md-6 col-lg-4">
        <div onClick={this.redirectTo} className="provider-card card">
          <div className="card-avatar-wrap">
            <div className="card-avatar-wrap-inner">
              {provider.profile_logo_url ? (
                <img src={provider.profile_logo_url} alt="avatar" />
              ) : (
                <img src={NO_AVA_BIG} alt="avatar" className="no-ava" />
              )}
            </div>
          </div>
          <div className="card-content-wrap">
            <div className="main-content">
              {/* <div className="profession">{provider.user_type}</div> */}
              <div className="name">{provider.name}</div>
              <div className="workshops">
                <span>Workshops:</span> {provider.provided_workshops.length}
              </div>
            </div>
            <div className="btn-wrap handlebar">
              {this.props.user.userLoggedIn() &&
              this.props.user.getUser().role === "admin" ? (
                <div className="edit-wrap">
                  <span
                    className="card-btn card-btn-delete"
                    onClick={this.handleOpenDeleteModal}
                  >
                    <span className="icon" />
                  </span>
                  <span
                    className="card-btn card-btn-edit"
                    onClick={this.handleEditProvider}
                  >
                    <span className="icon" />
                  </span>
                </div>
              ) : (
                <span className="provider-link">Contacts & bio</span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/ProviderCard.jsx